import get from "lodash/get";
import { useSelector } from "react-redux";
import { getBookDataPaginated } from "../store/actions/response.actions";
export var useHadQuery = function () {
    return useSelector(function (state) {
        var pageNumber = get(state, "courseReducer.pageNumber", 1);
        return [pageNumber, pageNumber - 1].map(function (number) {
            var _a, _b;
            return !!((_b = (_a = getBookDataPaginated(get(state, 'responseReducer'))[number]) === null || _a === void 0 ? void 0 : _a.queryString) === null || _b === void 0 ? void 0 : _b.includes("query="));
        })
            .some(Boolean);
    });
};
